// extracted by mini-css-extract-plugin
export var box = "box-module--box--2UJyb";
export var boxIcon = "box-module--box-icon--Zomu_";
export var boxContent = "box-module--box-content--1uiEq";